// extracted by mini-css-extract-plugin
export default {"Footer-Margin":"footer_Footer-Margin__RtUSN"};